<div *ngIf="finished==false" class='text-center'>
  <svg width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling"
    style="background: none;">
    <circle cx="50" cy="50" fill="none" stroke="#28a745" stroke-width="7" r="35"
      stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(346.659 50 50)">
      <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
        keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
    </circle>
  </svg>
</div>

<div *ngIf="no_recfound" class="text-center">
  {{mls?.languageText?.clinical?.key1}}<span *ngIf="mls?.is_lskey_display==1">(clinical.key1)</span>
</div>

<div class="text-center" *ngIf="has_error==true">
  {{mls?.languageText?.clinical?.key2}}<span *ngIf="mls?.is_lskey_display==1">(clinical.key2)</span>
  <div class="mt-2">
    <a class="cursor-pointer" (click)="getApiService.navigateToHome()"><span class="text-success">
        {{mls?.languageText?.clinical?.key3}}<span *ngIf="mls?.is_lskey_display==1">(clinical.key3)</span></span></a>
  </div>
</div>

<div *ngIf="is_res_received && no_recfound==false" class="mt-2"
  [eventTracker]='{"category":"web_share","action":"click_on_clinical","product_type":product_type,"product_id":product_type_id}'>
  <div>
    <div>

      <div class="bg-white rounded mb-2 pt-3">
        <div class="bg-white">


          <div class="clinical-card-list fnt-size14px">
            <div class="row">

              <div class="col-md-2 col-12 pr-md-0 d-none d-md-block">
                <div class="border-right">
                  <div class="p-2">
                    <div class="border-bottom mb-3"
                      [ngClass]="{'d-none' : clinicalDetailData?.channel?.title=='' && clinicalDetailData?.channel?.channel_logo==''}"
                      *ngIf="clinicalDetailData?.channel!=null">
                      <div *ngIf="clinicalDetailData?.channel !=null && clinicalDetailData?.channel?.channel_logo!=''"
                        style="width: 40px;" class="profile-pic mr-2">

                        <img *ngIf="clinicalDetailData?.channel?.channel_logo!=''"
                          src={{clinicalDetailData?.channel?.channel_logo}}
                          onerror="this.src='assets/img/image_placeholder.svg'">
                      </div>
                      <p class="mb-1 fnt-weight500 fnt-size18px" *ngIf="clinicalDetailData?.channel?.title!=''">
                        {{clinicalDetailData?.channel?.title}} </p>
                      <p class="fnt-size12px fnt-weight500 text-medium-grey mb-3">
                        <span class="clinical-compny mr-4 position-relative">
                          <img class="mr-1 post-pic border" *ngIf="clinicalDetailData?.channel?.powered_by!=''"
                            [src]="clinicalDetailData?.channel?.powered_by"
                            onerror="this.src='assets/img/image_placeholder.svg'" />{{clinicalDetailData?.channel?.powered_by_label}}
                          {{clinicalDetailData?.channel?.powered_name}}</span>
                      </p>
                      <!-- <p class="fnt-weight500 text-medium-grey mb-2 fnt-size12px">{{clinicalDetailData?.channel?.powered_by_label}}</p>
              <img [src]="clinicalDetailData?.channel?.powered_by" /> -->

                      <p class="text-center" *ngIf="clinicalDetailData?.channel?.no_of_members!=''"
                        class="mb-3 fnt-size14px w-100">{{clinicalDetailData?.channel?.no_of_members}}</p>
                    </div>
                    <div class="row fnt-size12px">
                      <div class="like  text-center pt-md-2 pb-md-2 col-4 col-md-12" (click)="navigateto()">
                        <span class="cursor-pointer ">
                          <svg style="margin-top:-4px" width="18px" viewBox="0 0 16 16">
                            <defs>
                              <style>
                                .cls-lyk-card {
                                  fill: #a09fa0;
                                }
                              </style>
                            </defs>
                            <g id="Layer_3" data-name="Layer 3">
                              <path class="cls-lyk-card"
                                d="M4.53,13.74h.79l.66.7a2.39,2.39,0,0,0,1.73.76l4.34.07a2.1,2.1,0,0,0,2-1.6,1.55,1.55,0,0,0-.12-1s1.57-1.57.52-2.88a1.35,1.35,0,0,0,1-1.37,2.27,2.27,0,0,0-2.28-2.3H10V3.69A3,3,0,0,0,8.15.87L8,.8a.78.78,0,0,0-1.08.72V3.6a1.54,1.54,0,0,1-.2.76l-1,1.73a.52.52,0,0,1-.46.27H4.53" />
                              <path class="cls-lyk-card"
                                d="M2.71,14.63h0A2.19,2.19,0,0,1,.5,12.44v-5a2.2,2.2,0,0,1,4.4,0v5A2.19,2.19,0,0,1,2.71,14.63Zm0-8.69A1.47,1.47,0,0,0,1.23,7.4v5a1.45,1.45,0,0,0,1.45,1.45h0a1.46,1.46,0,0,0,1.46-1.45v-5A1.47,1.47,0,0,0,2.71,5.94Z" />
                            </g>
                          </svg><br />
                          <span>
                            <span> {{(clinicalDetailData?.like_count>0)? clinicalDetailData?.like_count :''}}</span>
                            {{mls?.languageText?.clinical?.key4}}<span
                              *ngIf="mls?.is_lskey_display==1">(clinical.key4)</span></span>
                        </span>
                      </div>
                      <div class="bookmark-modal text-center pt-md-2 pb-md-2 col-4 col-md-12" (click)="navigateto()">
                        <span class="cursor-pointer">
                          <svg width="20px" id="Layer_ bookmarked" data-name="Layer  bookmarked" viewBox="0 0 15 15">
                            <defs>
                              <style>
                                .cls-bookmark-card {
                                  fill: #a09fa0;
                                }
                              </style>
                            </defs>
                            <path class="cls-bookmark-card"
                              d="M11.54,12.84l-4-3.06-4,3.06v-10a.65.65,0,0,1,.65-.65h6.78a.65.65,0,0,1,.65.65Z" />
                          </svg><br /> <span> {{mls?.languageText?.clinical?.key5}}<span
                              *ngIf="mls?.is_lskey_display==1">(clinical.key5)</span></span>
                        </span>
                      </div>

                      <div class="text-center pt-md-2 pb-md-2 col-4 col-md-12" (click)="navigateto()">
                        <span class="cursor-pointer">
                          <svg width="20px" viewBox="0 0 16 16">
                            <defs>
                              <style>
                                .cls-shre-card {
                                  fill: #a09fa0;
                                }
                              </style>
                            </defs>
                            <g id="Layer_3" data-name="Layer 3">
                              <path class="cls-shre-card"
                                d="M9.5,13.2V9.92C5.33,9.92,2.58,11.2.5,14c.84-4,3.16-8,9-8.8V2l6,5.59Z" />
                            </g>
                          </svg><br /> {{mls?.languageText?.clinical?.key6}}<span
                            *ngIf="mls?.is_lskey_display==1">(clinical.key6)</span></span>

                      </div>
                    </div>
                    <hr class="d-block d-md-none" />
                    <!-- <div class="pt-2 pb-2 text-center">
                <span class="icon-dot-dot">         
                <svg id="Layer_1" width="25px" data-name="Layer 1" viewBox="0 0 16 16"><defs><style>.cls-edit-cmmnt{fill:#737475;}</style></defs><ellipse class="cls-edit-cmmnt" cx="13.57" cy="8" rx="1.43" ry="1.38"/><ellipse class="cls-edit-cmmnt" cx="8" cy="8" rx="1.43" ry="1.38"/><ellipse class="cls-edit-cmmnt" cx="2.43" cy="8" rx="1.43" ry="1.38"/></svg>
                </span>
            </div> -->

                  </div>
                </div>
              </div>
              <div class="col-12 col-md-10">
                <div class="pr-2 pb-2 pl-2 pl-md-0">

                  <p class="fnt-size18px text-very-dark"><b>{{clinicalDetailData?.title}}</b></p>
                  <p class="mb-1 text-dark-grey">
                    <span *ngFor=" let Cl of clinicalDetailData?.categories; " class="mr-2"><span
                        *ngIf="clinicalDetailData?.categories !=''">#</span>{{Cl?.category_name}}</span>
                  </p>
                  <p class="mb-2 fnt-weight500 text-medium-grey">{{clinicalDetailData?.institution_name}}</p>

                  <p class="fnt-size12px fnt-weight500 text-medium-grey mb-3">
                    <span class="clinical-compny mr-4 position-relative" *ngIf="clinicalDetailData?.pharma !=null">
                      <img class="mr-1 post-pic" src={{clinicalDetailData?.pharma?.banner}}
                        onerror="this.src='assets/img/image_placeholder.svg'" />{{clinicalDetailData?.pharma?.name}}</span>

                    <!-- <span class="clinical-compny mr-4 position-relative" *ngIf="clinicalDetailData?.channel !=null"><img class="mr-1" src={{clinicalDetailData?.channel?.target_image}}  onerror="this.src='assets/img/image_placeholder.svg'" />{{clinicalDetailData?.channel?.channel_name}}</span> -->
                  </p>

                  <!-- <div class="journal-list-img mb-3">
                <img src= {{clinicalDetailData?.banner}}  onerror="this.src='assets/img/image_placeholder.svg'" alt="" class="w-100 ">

              </div>     -->
                  <div *ngIf="clinicalDetailData?.channel?.pharma_classification!='pharma'  "
                    [ngClass]="{'hide-content overflow-hidden': content_condition==1}" class="position-relative">
                    <div id="inner-html" class="inner-html" innerHtml="{{prod_desc}}">
                    </div>
                  </div>


                  <!-- <div   innerHtml="{{ clinicalResourceDes}}" ></div> -->
                </div>

                <div *ngIf="clinicalDetailData?.channel?.pharma_classification=='pharma'">
                  <h3 class=" text-center mt-4"> {{mls?.languageText?.clinical?.key7}}<span
                      *ngIf="mls?.is_lskey_display==1">(clinical.key7)</span></h3>
                </div>
              </div>



            </div>



            <div class="lyk-div p-2 border-top" *ngIf="content_condition!=1">

              <div class="row">
                <div class="col-md-6">
                  <div *ngIf="clinicalDetailData?.channel!=null">
                    <div *ngIf="clinicalDetailData?.channel !=null" style="width: 40px;"
                      class="profile-pic mr-2 float-left">
                      <img src={{clinicalDetailData?.channel?.channel_logo}}
                        onerror="this.src='assets/img/image_placeholder.svg'">
                    </div>
                    <div class="float-left" style="width: 53%;">
                      <p class="mb-1 fnt-weight500">{{clinicalDetailData?.channel?.title}} </p>
                      <p class="fnt-size12px fnt-weight500 text-medium-grey mb-3">
                        <span class="clinical-compny mr-4 position-relative">
                          <img class="mr-1 post-pic border" [src]="clinicalDetailData?.channel?.powered_by"
                            onerror="this.src='assets/img/image_placeholder.svg'" />{{clinicalDetailData?.channel?.powered_by_label}}
                          {{clinicalDetailData?.channel?.powered_name}}</span>
                      </p>

                    </div>
                    <div class="float-right" style="width: 103px;">
                      <button (click)="navigateto()" *ngIf="clinicalDetailData?.channel?.subscribed_button_flag==1"
                        class="btn btn-success btn-sm mb-3 fnt-size14px w-100">+Subscribe</button>

                      <!-- (click)="showSubscribePopup(clinicalDetailData?.channel?.target_id)" -->
                    </div>
                  </div>

                </div>
                <div class="col-md-6">
                  <hr *ngIf="clinicalDetailData?.channel?.channel_logo!='' || clinicalDetailData?.channel?.title!=''"
                    class="d-block d-md-none" />
                  <div class="row">
                    <div class="like col-md-4 col-4 text-center pt-2 pb-2" (click)="navigateto()">
                      <span class="cursor-pointer">

                        <svg style="margin-top:-4px" width="18px" viewBox="0 0 16 16">
                          <defs>
                            <style>
                              .cls-lyk-card {
                                fill: #a09fa0;
                              }
                            </style>
                          </defs>
                          <g id="Layer_3" data-name="Layer 3">
                            <path class="cls-lyk-card"
                              d="M4.53,13.74h.79l.66.7a2.39,2.39,0,0,0,1.73.76l4.34.07a2.1,2.1,0,0,0,2-1.6,1.55,1.55,0,0,0-.12-1s1.57-1.57.52-2.88a1.35,1.35,0,0,0,1-1.37,2.27,2.27,0,0,0-2.28-2.3H10V3.69A3,3,0,0,0,8.15.87L8,.8a.78.78,0,0,0-1.08.72V3.6a1.54,1.54,0,0,1-.2.76l-1,1.73a.52.52,0,0,1-.46.27H4.53" />
                            <path class="cls-lyk-card"
                              d="M2.71,14.63h0A2.19,2.19,0,0,1,.5,12.44v-5a2.2,2.2,0,0,1,4.4,0v5A2.19,2.19,0,0,1,2.71,14.63Zm0-8.69A1.47,1.47,0,0,0,1.23,7.4v5a1.45,1.45,0,0,0,1.45,1.45h0a1.46,1.46,0,0,0,1.46-1.45v-5A1.47,1.47,0,0,0,2.71,5.94Z" />
                          </g>
                        </svg>

                        <br />
                        <span><span *ngIf="clinicalDetailData?.like_count > 0">
                            {{clinicalDetailData?.like_count}}</span> {{mls?.languageText?.clinical?.key4}}<span
                            *ngIf="mls?.is_lskey_display==1">(clinical.key4)</span></span> </span>
                    </div>

                    <div class="bookmark-modal col-md-4 col-4 text-center pt-2 pb-2" (click)="navigateto()">
                      <span class="cursor-pointer">
                        <svg width="20px" id="Layer_ bookmarked" data-name="Layer  bookmarked" viewBox="0 0 15 15">
                          <defs>
                            <style>
                              .cls-bookmark-card {
                                fill: #a09fa0;
                              }
                            </style>
                          </defs>
                          <path class="cls-bookmark-card"
                            d="M11.54,12.84l-4-3.06-4,3.06v-10a.65.65,0,0,1,.65-.65h6.78a.65.65,0,0,1,.65.65Z" />
                        </svg><br />
                        <span> {{mls?.languageText?.clinical?.key5}}<span
                            *ngIf="mls?.is_lskey_display==1">(clinical.key5)</span></span>
                      </span>
                    </div>

                    <div class="share col-md-4 col-4 text-center pt-2 pb-2" (click)="navigateto()">
                      <span class="cursor-pointer">
                        <svg width="20px" viewBox="0 0 16 16">
                          <defs>
                            <style>
                              .cls-shre-card {
                                fill: #a09fa0;
                              }
                            </style>
                          </defs>
                          <g id="Layer_3" data-name="Layer 3">
                            <path class="cls-shre-card"
                              d="M9.5,13.2V9.92C5.33,9.92,2.58,11.2.5,14c.84-4,3.16-8,9-8.8V2l6,5.59Z" />
                          </g>
                        </svg><br /> {{mls?.languageText?.clinical?.key6}}<span
                          *ngIf="mls?.is_lskey_display==1">(clinical.key6)</span></span>

                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="p-2 bg-white shadow border-top fixed-bottom" *ngIf="content_condition==1">
    <div class="container">
      <div class="row">
        <div class="col-3">

        </div>
        <div class="col-9 text-right">
          <span class="btn btn-success pl-3 pr-3 fnt-size14px pt-2 pb-2 cursor-pointer" (click)="navigateto()">
            {{mls?.languageText?.clinical?.key8}}<span *ngIf="mls?.is_lskey_display==1">(clinical.key8)</span></span>
        </div>
      </div>

    </div>
  </div>



</div>



<!-- Bookmark end -->